import React, { memo, useEffect, useRef, useState } from "react";
import Footer from "../../Footer";
import Navbar from "../../Navbar";
import DisclosureComponent from "./DisclosureComponent";
import { HiOutlineMail } from "react-icons/hi";
import { MdCall } from "react-icons/md";
import { BsChat } from "react-icons/bs";
import SignedInNavbarImproved from "../../SignedInNavbarImproved";
import { authService } from "../../../services/authService";

function ContactUs() {
  const [includeScript, setIncludeScript] = useState(false);
  const token = authService.getToken();

  const scriptToInject = `
    <script id="zim-messageScript" type="text/javascript">var _d=document;_d.write('<div id="zim-messageWidget" style="display:flex;align-items:center;cursor:pointer;width:100%;" onclick=window.open("https://wa.me/2348141530208?text=Thank%20you%20for%20contacting%20Grocedy%20Customer%20Support.%20How%20may%20we%20assist%20you%20today%3F%0A")><div style="display:flex;align-items:center;max-width:100%;border:1px solid transparent;box-sizing:border-box;background-color:#065E54;border-color:#065E54;color:#fff;border-radius:0px;min-height:36px;padding:9px 15px"><div style="flex-shrink:0;width:18px;height:18px"><svg style="fill: currentColor;" id=WHATSAPP viewBox="0 0 17 17"><path d="M16.5333 8.7668C16.5333 13.0668 13.02 16.5535 8.67999 16.5535C7.29999 16.5535 6.01333 16.2001 4.87999 15.5868L0.533325 16.9668L1.95333 12.7868C1.21185 11.5746 0.81965 10.1811 0.819992 8.76013C0.826659 4.45346 4.34666 0.966797 8.68666 0.966797C13.0133 0.966797 16.5333 4.45346 16.5333 8.7668ZM8.67999 2.20013C5.03999 2.20013 2.07999 5.14013 2.07999 8.75346C2.07999 10.1868 2.54666 11.5135 3.33333 12.5935L2.50666 15.0335L5.03999 14.2335C6.12135 14.9422 7.38707 15.3178 8.67999 15.3135C12.32 15.3135 15.28 12.3801 15.28 8.76013C15.2712 7.01671 14.5715 5.3479 13.3343 4.11948C12.0972 2.89106 10.4234 2.20325 8.67999 2.2068V2.20013ZM12.6467 10.5535C12.5933 10.4735 12.4667 10.4268 12.2733 10.3335C12.0867 10.2401 11.14 9.77346 10.96 9.71346C10.7867 9.6468 10.6533 9.61346 10.5267 9.8068C10.3933 10.0001 10.0267 10.4268 9.91999 10.5535C9.80666 10.6868 9.69333 10.7001 9.49999 10.6068C9.30666 10.5068 8.68666 10.3068 7.95333 9.65346C7.53454 9.26854 7.17509 8.82372 6.88666 8.33346C6.76666 8.14013 6.86666 8.04013 6.96666 7.9468C7.05333 7.86013 7.15999 7.72013 7.25333 7.61346C7.35333 7.50013 7.38666 7.41346 7.44666 7.29346C7.51333 7.16013 7.47999 7.05346 7.43333 6.96013C7.37999 6.86013 6.99999 5.92013 6.83333 5.54013C6.67333 5.15346 6.51333 5.22013 6.40666 5.22013C6.29333 5.22013 6.15999 5.20013 6.03333 5.20013C5.89999 5.20013 5.69999 5.25346 5.51999 5.44013C5.34666 5.63346 4.85333 6.09346 4.85333 7.04013C4.85333 7.97346 5.53999 8.88013 5.63333 9.01346C5.72666 9.14013 6.96666 11.1268 8.91999 11.8935C10.88 12.6601 10.88 12.4068 11.2333 12.3735C11.5867 12.3401 12.3667 11.9068 12.5333 11.4668C12.6933 11.0201 12.6933 10.6335 12.6467 10.5535Z"></path></svg></div>&nbsp;<div style="word-break:break-word;font-size:14px;margin-left:7px">Message us on WhatsApp</div></div></div>');var _zim = _d.getElementById("zim-messageWidget");var _r = _d.getElementById("zim-messageScript");_r.parentNode.insertBefore(_zim, _r);</script>
  `;

  const InjectScript = memo(({ script }) => {
    const divRef = useRef(null);

    useEffect(() => {
      if (divRef.current === null) {
        return;
      }
      // create a contextual fragment that will execute the script
      // beware of security concerns!!
      const doc = document.createRange().createContextualFragment(script);

      // clear the div HTML, and append the doc fragment with the script
      divRef.current.innerHTML = "";
      divRef.current.appendChild(doc);
    });

    return <div ref={divRef} />;
  });

  const toggleIncludeScript = () => setIncludeScript((include) => !include);

  return (
    <div>
       {token ? <SignedInNavbarImproved /> : <Navbar />}
      {includeScript && <InjectScript script={scriptToInject} />}
      <div className="mx-auto mt-12 max-w-[1600px] px-4 xsm:px-6">
        <div className="mx-auto max-w-4xl">
          <h3 className="text-center text-sm font-semibold text-olivine-500">
            Contact Us
          </h3>
          <p className="mt-1 text-center text-2xl font-semibold text-gray-600">
            We would love to hear from you
          </p>
        </div>
        <div className="mx-auto mt-10 grid max-w-5xl gap-4 grid-auto-fit-sm">
          <div className="flex max-w-sm flex-col rounded-xl border-[0.5px] border-olivine-500 bg-[#F6FBEE] p-6">
            <div className="flex justify-start">
              <div className="rounded-md bg-olivine-500 p-2">
                <HiOutlineMail className="h-5 w-5 text-white" />
              </div>
            </div>
            <h3 className="mt-4 text-lg font-semibold text-gray-700">
              Send us a Mail
            </h3>
            <p className="mt-2 text-xs text-gray-700">
              If you have any questions or need more information about our
              products and services, please contact our customer service on;
            </p>
            <a href="#" className="mt-4 text-sm text-olivine-500 underline">
              customercare@grocedy.com
            </a>
          </div>
          <div className="flex max-w-sm flex-col rounded-xl border-[0.5px] border-olivine-500 bg-[#F6FBEE] p-6">
            <div className="flex justify-start">
              <div className="rounded-md bg-olivine-500 p-2">
                <MdCall className="h-5 w-5 text-white" />
              </div>
            </div>
            <h3 className="mt-4 text-lg font-semibold text-gray-700">
              Call customer Service
            </h3>
            <p className="mt-2 text-xs text-gray-700">
              If you have any questions or need more information about our
              products and services, please contact our customer service on
              Mondays - Fridays from 8am to 5pm.
            </p>
            <a href="#" className="mt-4 text-sm font-semibold text-olivine-500">
              0700GROCEDY
            </a>
          </div>
          <div className="flex max-w-sm flex-col rounded-xl border-[0.5px] border-olivine-500 bg-[#F6FBEE] p-6">
            <div className="flex justify-start">
              <div className="rounded-md bg-olivine-500 p-2">
                <BsChat className="h-5 w-5 text-white" />
              </div>
            </div>
            <h3 className="mt-4 text-lg font-semibold text-gray-700">
              Chat with a Support agent
            </h3>
            <p className="mt-2 text-xs text-gray-700">
              You can communicate with grocedy suport agent through the Whatsapp
              chatbot or our Real time messaging live-chat.
            </p>
            <div className="mt-4 flex w-full flex-col space-y-3 text-sm font-semibold text-white sm:flex-row sm:items-center sm:justify-between sm:space-x-2 sm:space-y-0">
              <button className="w-full rounded-md bg-olivine-500 px-4 py-2 transition-all duration-200 hover:opacity-80 active:bg-olivine-600 sm:w-auto">
                Live chat
              </button>{" "}
              <button
                onClick={toggleIncludeScript}
                className="w-full rounded-md bg-olivine-500 px-4 py-2 transition-all duration-200 hover:opacity-80 active:bg-olivine-600 sm:w-auto"
              >
                Chat on Whatsapp
              </button>
            </div>
          </div>
        </div>
        <div>
          <h3 className="mt-20 text-center text-2xl font-semibold text-gray-600">
            Frequently asked questions
          </h3>
        </div>
        <div className="mx-auto mt-10 max-w-3xl space-y-4">
          <DisclosureComponent
            question="What do I do if my phone number or email already exists?"
            answer1="If your phone number or email address already exists"
            answer2={
              <p className="mt-2 text-sm">
                STEP 1: Click on "Forgot Password" on our mobile or web app
              </p>
            }
            answer3={
              <p className="text-sm">
                STEP 2: Select your recovery method channel (phone or email)
              </p>
            }
            answer4={
              <p className="text-sm">
                STEP 3: Enter the OTP code that was sent to your selected
                channel
              </p>
            }
            answer5={
              <p className="text-sm">
                STEP 4: Update your{" "}
                <span className="font-bold">New Password</span> and Proceed.
              </p>
            }
          />
          <DisclosureComponent
            question="How do I reset my transaction PIN?"
            answer1={
              <p>
                To reset your <span className="font-bold">Transaction PIN</span>
                , follow these steps:
              </p>
            }
            answer2={
              <ul className="mt-4 font-bold">
                Mobile Application
                <li className="font-normal">
                  STEP 1: Login to your Grocedy Mobile App
                </li>
                <li className="font-normal">STEP 2: Click on Settings</li>
                <li className="font-normal">STEP 3: Select "Pin"</li>
                <li className="font-normal">
                  STEP 4: Choose your preferred method
                </li>
              </ul>
            }
            answer3={
              <ul className="mt-4 font-bold">
                Grocedy Web
                <li className="font-normal">
                  STEP 1: Login to your Grocedy account
                </li>
                <li className="font-normal">
                  STEP 2: Click on "Profile" at the top right
                </li>
                <li className="font-normal">STEP 3: Select "Pin"</li>
                <li className="font-normal">
                  STEP 4: Choose your preferred method
                </li>
              </ul>
            }
          />
          <DisclosureComponent
            question="How do I change my Password? "
            answer1={
              <p>
                To change your <span className="font-bold">Password</span>, you
                can follow these steps:
              </p>
            }
            answer2={
              <ul className="mt-4 font-bold">
                Mobile Application
                <li className="font-normal">
                  STEP 1: Login to your Grocedy Mobile App
                </li>
                <li className="font-normal">STEP 2: Click on "Settings"</li>
                <li className="font-normal">STEP 3: Select "Password"</li>
                <li className="font-normal">
                  STEP 4: Enter your email address to reset your password.
                </li>
                <li className="font-normal">
                  STEP 5: Input the OTP that was sent to your email address
                </li>
                <li className="font-normal">
                  STEP 6: Update your new password to proceed.
                </li>
              </ul>
            }
            answer3={
              <ul className="mt-4 font-bold">
                Grocedy Web
                <li className="font-normal">
                  STEP 1: Login to your Grocedy account
                </li>
                <li className="font-normal">
                  STEP 2: Click on "Profile" at the top right
                </li>
                <li className="font-normal">STEP 3: Select "Password"</li>
                <li className="font-normal">
                  STEP 4: Enter your email address to reset your password.
                </li>
                <li className="font-normal">
                  STEP 5: Input the OTP that was sent to your email address
                </li>
                <li className="font-normal">
                  STEP 6: Update your new password to proceed.
                </li>
              </ul>
            }
          />
          <DisclosureComponent
            question="How do I delete my Grocedy Account?"
            answer1="To close your Grocedy account, you can follow these steps:"
            answer2={
              <ul className="mt-2">
                <li className="font-normal">
                  STEP 1: Login to your Grocedy Mobile App
                </li>
                <li className="font-normal">STEP 2: Click on "Settings" </li>
                <li className="font-normal">STEP 3: Select "Delete account"</li>
                <li className="font-normal">
                  STEP 4: Chat with a support agent to assist with your request
                </li>
              </ul>
            }
            answer3={
              <p className="mt-4">
                Please note that deleting your Grocedy account will permanently
                remove all records and data we have. It is not reversible.{" "}
              </p>
            }
          />
          <DisclosureComponent
            question="How do I change my Account information?"
            answer1={
              <p>
                If you want to change any information on your Grocedy account,
                you can do so by following these steps:
              </p>
            }
            answer2={
              <ul className="mt-4 font-bold">
                Mobile Application
                <li className="font-normal">
                  STEP 1; Login to your mobile app
                </li>
                <li className="font-normal">STEP 2: Go to settings</li>
                <li className="font-normal">
                  STEP 3: Select what information you will like to change
                </li>
                <li className="font-normal">STEP 4: Click on Save details</li>
              </ul>
            }
            answer3={
              <ul className="mt-4 font-bold">
                Grocedy Web
                <li className="font-normal">
                  STEP 1; Login to your Grocedy account
                </li>
                <li className="font-normal">
                  STEP 2: Go to your profile at the top right
                </li>
                <li className="font-normal">
                  STEP 3: Select what information you will like to change
                </li>
                <li className="font-normal">STEP 4: Click on Save details</li>
              </ul>
            }
            answer4={
              <p className="mt-4">
                <span className="font-bold">Note: </span> Email address and
                phone number cannot be changed once it has been verified.
                Contact customer support to assist you with this change.
              </p>
            }
          />

          <DisclosureComponent
            question="How do I create an account on Grocedy?"
            answer1="To create a Grocedy account, you have three options:"
            answer2={
              <div className="px-4">
                <ul className="mt-4 list-outside list-decimal space-y-2 font-bold">
                  <li>
                    Visit grocedy.com and follow the sign-up process:
                    <div className="ml-4">
                      <ul className="list-disc font-normal">
                        <li>Go to grocedy.com</li>
                        <li>Click on the "Sign Up" button.</li>
                        <li>
                          Fill in your credentials, including your name, email
                          address, and password.
                        </li>
                        <li>
                          Complete the required information and click on the
                          "Create Account" button.
                        </li>
                        <li>
                          A confirmation mail will be sent to your email
                          address. Follow the instructions in the email to
                          verify your account.
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    Download the Grocedy mobile app for iOS or Android:{" "}
                    <div className="ml-4">
                      <ul className="list-disc font-normal">
                        <li>
                          Go to the App Store (iOS) or Google Play Store
                          (Android).
                        </li>
                        <li>Search for "Grocedy" and download the app.</li>
                        <li>Open the app and click on the "Sign Up" button.</li>
                        <li>
                          Fill in your credentials, including your name, email
                          address, and password.
                        </li>
                        <li>
                          Complete the required information and click on the
                          "Create Account" button.
                        </li>
                        <li>
                          A confirmation mail will be sent to your email
                          address. Follow the instructions in the email to
                          verify your account.
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    Chat with Mama, our WhatsApp Chat Bot:{" "}
                    <div className="">
                      <ul className="font-normal">
                        <li>
                          Additionally, you can go through the account creation
                          process, by saving our WhatsApp number 08184223072 and
                          saying "Hi" to Mama, our WhatsApp chat bot. Follow the
                          prompts thereafter.
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            }
          />
          <DisclosureComponent
            question="What is Pay Bills on Grocedy?"
            answer1="The Pay Bill service on the Grocedy platform allows users to conveniently and efficiently make online payments for various bills such as electricity, cable subscriptions, and more. Here's how you can use it:"
            answer2={
              <ul className="mt-4 list-outside list-decimal px-4">
                <li> Begin by logging into your Grocedy account.</li>
                <li> Navigate to the wallet section within your account.</li>
                <li>
                  Look for the option labeled "Bills Payment" and select it.
                </li>
                <li>
                  {" "}
                  You will be presented with a list of available billers. Choose
                  the specific service provider you need to pay.
                </li>
                <li>
                  {" "}
                  Enter the necessary information for the biller, such as your
                  account number or customer ID.
                </li>
                <li>
                  After entering the required details, click on the "Next"
                  button to review and confirm the accuracy of the information
                  you provided.
                </li>
                <li>
                  Once you have verified the details, click on the "Proceed"
                  button to initiate the payment process.
                </li>
              </ul>
            }
            answer3={
              <p className="mt-4">
                By following these steps, you can effectively utilize the Pay
                Bill service offered by Grocedy to conveniently settle your
                bills online. If you have any further questions or require
                additional assistance, feel free to ask!
              </p>
            }
          />
          <DisclosureComponent
            question="What is Auto Fund?"
            answer1='"Auto fund" is a feature on the Grocedy platform that enables users to set up recurring contributions to their Grocedy wallet. It allows users to automatically save money for their food purchases by setting up daily, weekly, or monthly direct debits from their card. The payments are processed securely through the Flutterwave payment gateway.'
          />
          <DisclosureComponent
            question="How can I set my auto fund? "
            answer1={
              <div>
                <ul className="mt-4 font-bold">
                  This can only be done via card payment
                  <li className="mt-1 font-normal">
                    STEP 1: Go to wallet, click on Auto fund{" "}
                  </li>
                  <li className="font-normal">STEP 2: Input amount</li>
                  <li className="font-normal">
                    STEP 3: Select your schedule (daily, weekly or monthly)
                  </li>
                  <li className="font-normal">STEP 4: Click on Continue </li>
                </ul>
                <ul className="mt-4 list-inside list-disc font-bold">
                  What else can I do with my auto fund?
                  <li className="mt-1 font-normal">
                    You can cancel a recurring auto-fund
                  </li>
                  <li className="font-normal">You can edit your auto-fund</li>
                  <li className="font-normal">
                    With Auto fund, you earn more points which you can redeem on
                    the platform for food items.
                  </li>
                </ul>
              </div>
            }
          />
          <DisclosureComponent
            question="What is a recurring payment?"
            answer1={
              <p>
                Recurring payment is a convenient feature for you to ensure your
                food items get delivered to you at a certain period every month.
                It allows you to set up automated and regular purchases of your
                preferred food baskets or add-ons. By opting for a recurring
                purchase, we will deduct the necessary amount from your Grocedy
                Wallet every month. This means you don't have to worry about
                manually placing an order or making a payment each time. It's a
                hassle-free way to ensure that your monthly foodstuff and other
                desired items are delivered without any extra effort on your
                part.
              </p>
            }
            answer2={
              <p className="mt-2">
                To activate the recurring feature, simply select the "recurring"
                option when subscribing to a basket or when customizing your own
                basket with specific items.
              </p>
            }
            answer3={
              <p className="mt-2">
                Always ensure you have enough money in your wallet so that the
                deduction can take place.
              </p>
            }
          />
          <DisclosureComponent
            question="How long does it take for my Payment to be processed?"
            answer1="Payments into your unique Grocedy account (viewed on your wallet page) or through the payment gateways on our apps, usually appear in your wallet within a few seconds. Occasionally, there might be delays in seeing these payments, this is dependent on network connections or from your bank. "
          />
          <DisclosureComponent
            question="How do I know if my payment has been processed successfully?"
            answer1="Once you have initiated a transaction, your wallet will be updated immediately. You will also receive an email to notify you of the transaction, this includes your auto fund payments. "
            answer2={
              <p className="mt-4">
                <span className="font-bold">Note: </span>If your wallet has not
                been updated, kindly chat with us on our live chat or send an
                email to{" "}
                <span className="font-semibold">customercare@grocedy.com</span>{" "}
                to lodge a complaint.
              </p>
            }
          />
          <DisclosureComponent
            question="How can I make a payment?"
            answer1={
              <p>
                Visit{" "}
                <a
                  href="https://www.grocedy.com/"
                  target="blank"
                  className="text-blue-600 hover:underline hover:underline-offset-2"
                >
                  www.grocedy.com
                </a>{" "}
                or download our mobile apps on Android or IOS.
              </p>
            }
            answer2={
              <ul className="mt-4">
                <li className="mt-1 font-normal">
                  Step 1: Login to your platform
                </li>
                <li className="font-normal">STEP 2: Go to your wallet</li>
                <li className="font-normal">
                  STEP 3: Bank Transfer: Copy your unique account number to do a
                  direct transfer from your bank
                </li>
                <li className="font-normal">
                  Step 4: Card Payment: Click on fund wallet and pay securely
                  through Flutterwave
                </li>
              </ul>
            }
            answer3={
              <p className="mt-4 font-bold">
                You can also fund your wallet a lot more conveniently by
                selecting the auto fund option on your wallet page.
              </p>
            }
          />
          <DisclosureComponent
            question="Can I cancel my order and get a refund after payment has been made?"
            answer1="No! Once an item has been purchased, an order cannot be canceled. Please refer to our policy to know about our refund policy. We are however happy to replace any item you are not completely satisfied with."
          />
          <DisclosureComponent
            question="What should I do if I was debited twice from my bank?"
            answer1="If you were debited twice from your bank, kindly check your bank notification to validate if a reversal has been done. If you have yet to see the amount debited in your account, please reach out to your bank for a refund and also let us know via live chat."
          />
          <DisclosureComponent
            question="Can I pay with cash on delivery?"
            answer1="No, we do not accept cash on delivery. The full payment must be deducted from your wallet on the platform before delivery is initiated."
          />
          <DisclosureComponent
            question="What should I do if my payment is declined?"
            answer1={
              <p className="text-xs italic">
                You attempted to pay via your debit card and wrongly entered the
                security pin, name, and expiry date or your card has not been
                activated to process online purchases.
              </p>
            }
            answer2={
              <p className="mt-2 font-bold">
                We suggest that you transfer the amount into your unique Grocedy
                account number (visible on your wallet page) from your bank app
                or bank USSD channel. This remains the quickest way to fund your
                wallet.
              </p>
            }
            answer3={
              <ul className="mt-4 list-outside list-disc space-y-2 px-4">
                <li>
                  Other reasons could be that you did not update the OTP sent
                  via email. Most times, it could be the phone number registered
                  with your bank account is different from the one that you were
                  using at the time of the transaction. Please contact your bank
                  to update the correct phone number.
                </li>
                <li>
                  You have insufficient funds. In this case, you have to make a
                  transaction after you have sufficient funds in your bank
                  account.
                </li>
                <li>The bank has declined to process your transaction.</li>
                <li>
                  If any amount was debited from your bank account, please
                  contact us at customercare@grocedy.com or chat with us.{" "}
                </li>
              </ul>
            }
            answer4={
              <p className="mt-4 font-bold">
                <span className="mb-2 rounded-sm bg-[#EF7008] px-4 py-2 leading-9 text-white">
                  Please Note:
                </span>
                <br />
                Grocedy will never ask for your password, pin, CVV, or full card
                details via telephone call or email
              </p>
            }
          />
          <DisclosureComponent
            question="How secure is my payment information on Grocedy?"
            answer1="Grocedy is committed to using the best available technology and procedures to protect the security of your online transactions."
            answer2="Your security is our foremost priority, so we work with PCI DSS-complaint payment processor, Flutterwave, to handle your card details."
            answer3="None of your card details are ever stored on our systems."
            answer4="Your unique bank account is provided by our banking partners and receiving funds into these accounts is extremely secure."
          />
          <DisclosureComponent
            question="What payment method is accepted?"
            answer1="To fund your wallet, you can pay via transfer, directly into the unique account number shown on your wallet page. You can choose Flutterwave and select any of the payment methods you would like to use. For auto fund, your card details are required by our payment processor to process your payment."
          />
          <DisclosureComponent
            question="Can I change my delivery address after placing an order?"
            answer1="Unfortunately, it is not possible to change your delivery address after placing an order. Therefore, it is vitally important to double-check and confirm your delivery information, including your address and phone number (in the settings page of our mobile and web app), before proceeding with the checkout process. This ensures that your order will be delivered to the intended location accurately. If you need any assistance or have any concerns regarding your delivery address, it is recommended to reach out to our support team via the Live Chat option for a quick resolution.
"
          />
          <DisclosureComponent
            question="What if I am not available to receive my order?"
            answer1='If you are not available to receive your order, kindly contact the delivery agent on your mobile or web app through the "Track your order" feature on your home page, to reschedule your order for delivery, or contact customercare@grocedy.com. We will reschedule a delivery, once, free of charge. If we have to reschedule it more than once, there will be an extra charge for this.'
          />
          <DisclosureComponent
            question="Can my order be delivered outside Lagos?"
            answer1="No! We only deliver within Lagos and Ogun State for now, but we will be expanding our services to other parts of the country in due course.
"
          />
          <DisclosureComponent
            question="What happens if I do not receive my order at the said time?"
            answer1="If your order has not been delivered within the time frame, you can follow these steps:"
            answer2="Contact the delivery agent by using the contact information provided  in the mail that was sent "
            answer3="If you are unable to get in touch with the delivery agent, you can reach out to Grocedy Customer support team for assistance"
            answer4="Go to contact us on the website or App and select any option to reach out to us. "
            answer5={
              <p className="mt-4">
                <span className="font-bold">Note: </span>We take all measures to
                ensure that your basket is in stock at one of our delivery hubs
                closest to your shipping address and delivered to you timely. If
                your basket is not in stock for any reason and ready to ship; we
                might extend the delivery time by 24 hours and inform you
                accordingly. But we will always ensure you receive it within 3
                working days.
              </p>
            }
          />
          <DisclosureComponent
            question="How long will my order take to arrive?"
            answer1="We typically fulfill all orders within 3 working days, upon completion of payment of your plan. Your order will be processed for shipping. Any order placed after business hours on Friday or during the weekend/holidays will be shipped out the following working day."
          />
          <DisclosureComponent
            question="How do I track my order?"
            answer1="To track your order on Grocedy, please follow these steps"
            answer2={
              <ul className="mt-2 px-4">
                <li>Step 1: Login to your Grocedy account</li>
                <li>Step 2: Go to your home page</li>
                <li>
                  Step 3: Select the order you want to track the delivery status
                  and click on details
                </li>
              </ul>
            }
          />
          <DisclosureComponent
            question="What is Pay Bills on Grocedy?"
            answer1="The Pay Bill service on the Grocedy platform allows users to conveniently and efficiently make online payments for various bills such as electricity, cable subscriptions, and more. Here's how you can use it:"
            answer2={
              <ul className="mt-2 list-decimal px-4">
                <li> Begin by logging into your Grocedy account.</li>
                <li>Navigate to the wallet section within your account.</li>
                <li>
                  Look for the option labeled "Bills Payment" and select it.
                </li>
                <li>
                  You will be presented with a list of available billers. Choose
                  the specific service provider you need to pay.
                </li>
                <li>
                  {" "}
                  Enter the necessary information for the biller, such as your
                  account number or customer ID.
                </li>
                <li>
                  After entering the required details, click on the "Next"
                  button to review and confirm the accuracy of the information
                  you provided.
                </li>
                <li>
                  {" "}
                  Once you have verified the details, click on the "Proceed"
                  button to initiate the payment process.
                </li>
              </ul>
            }
            answer3={
              <p className="mt-4">
                By following these steps, you can effectively utilize the Pay
                Bill service offered by Grocedy to conveniently settle your
                bills online. If you have any further questions or require
                additional assistance, feel free to ask!
              </p>
            }
          />
          <DisclosureComponent
            question="How can I provide feedback or write a review for a Product?"
            answer1={
              <p>
                To provide feedback or write a review for a product on Grocedy,
                you have a few options. Firstly, you can give feedback after the
                delivery has been made by accessing the{" "}
                <span className="font-bold">"Track your order"</span> link on
                your Grocedy home page. This will allow you to provide your
                thoughts on the overall experience or specifically rate and
                review the product you purchased.
              </p>
            }
            answer2={
              <p className="mt-4">
                Alternatively, you can also send your feedback directly to
                Grocedy by emailing us at{" "}
                <span className="font-semibold">customercare@grocedy.com</span>.
                This way, you can share your feedback and experience with the
                product or service in detail.
              </p>
            }
            answer3={
              <p className="mt-4">
                Lastly, for a more immediate response, you can utilize the live
                chat feature on our Grocedy app to directly communicate with our
                support team. This allows you to express your feedback or
                concerns directly and receive prompt assistance.l from our
                grocers.
              </p>
            }
          />
          <DisclosureComponent
            question="How can I view the content of the package I want to choose?"
            answer1="To view the content in your selected package: "
            answer2={
              <ul className="mt-2">
                <li>STEP 1: Login to your grocedy account</li>
                <li>STEP 2: Go to product, and select Food basket</li>
                <li>
                  Step 3: Scroll to your preferred plan and click on view
                  content
                </li>
              </ul>
            }
          />
          <DisclosureComponent
            question="What are the services Grocedy offers?"
            answer1="Grocedy offers a range of services to make food shopping and delivery more convenient for our users. Some of the services we provided include:"
            answer2={
              <ul className="mt-2 list-decimal px-4">
                <li>
                  Online Food purchasing: we allow our users to browse and
                  purchase a wide variety of grocery items including foodstuffs,
                  meats, and chicken, directly from our platform. Users can
                  conveniently order their desired products from the comfort of
                  their homes either as a one-off or recurring basis (monthly).
                </li>
                <li>
                  Customized Baskets: Users have the option to create their own
                  customized grocery baskets by selecting specific items they
                  need. This gives them more flexibility and control over their
                  shopping experience.{" "}
                </li>
                <li>
                  Recurring Purchases: Grocedy enables users to set up recurring
                  purchases for their favorite food baskets or add-ons. This
                  feature ensures automated and regular delivery of essential
                  items without the need for manual ordering each time. Users
                  can also pick from one of our specially curated baskets.
                </li>
                <li>
                  Bill Payment: Grocedy provides a service for users to make
                  online payments for airtime top-ups, data bundles, and various
                  bills, such as electricity bills and cable subscriptions,
                  directly through the platform. This eliminates the need for
                  separate payment portals and simplifies the bill payment
                  process.
                </li>
                <li>
                  Order Tracking: Grocedy offers a tracking feature where users
                  can monitor the status of their orders in real time. This
                  allows users to stay informed about the progress of their
                  delivery and anticipate its arrival.
                </li>
              </ul>
            }
            answer3={
              <p className="mt-4">
                These are some of the key services offered by Grocedy to enhance
                your experience and make it more convenient for our users.
              </p>
            }
          />
          <DisclosureComponent
            question="Why do I see two different prices on a particular Item?"
            answer1="The prices you see is the Grocedy price (in black) and the market price (in red). The difference is the amount you have saved buying from Grocedy."
          />
          <DisclosureComponent
            question="What is the minimum amount to purchase when ordering from “pick your basket”?"
            answer1='The minimum order to purchase when creating your own basket is ₦12,000. This minimum order also applies to "The Butchers".'
          />
          <DisclosureComponent
            question="What is your Return / Refund Policy?"
            answer1={
              <ul className=" list-disc px-4">
                <li>
                  Any item can be returned at any time up to 72 hours after
                  delivery.{" "}
                </li>
                <li>
                  We do not accept returns for refund. If there is an issue with
                  an item, we can only offer a replacement or credit your
                  account with us.
                </li>
                <li>
                  Grocedy does not offer refunds, however, we are more than
                  happy to replace any item, you are not satisfied with
                </li>
              </ul>
            }
          />
          <DisclosureComponent
            question="How do I return an Item? "
            answer1={
              <p>
                You can reach out to us at{" "}
                <span className="font-semibold">customercare@grocedy.com</span>{" "}
                to lodge a complaint for a possible return. We will have an
                agent pick up the item at your location.
              </p>
            }
          />
          <DisclosureComponent
            question="I am no longer interested in continuing with my order, I need a refund"
            answer1={
              <p>
                Grocedy does not offer a refund once your wallet has been topped
                up. However, we would like feedback on why you do not wish to
                continue with your order. You can send us an email to leave your
                feedback at{" "}
                <span className="font-semibold">customercare@grocedy.com</span>
              </p>
            }
            answer2="You can also use your wallet balance to pay for airtime, data bundles, or pay bills."
          />
          <DisclosureComponent
            question="I am not satisfied with my order, I need a refund"
            answer1="We do not offer a refund for a purchased basket. If you are not completely happy with a particular item in your basket, we would be happy to assist in processing a replacement within the time of the returned item. "
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ContactUs;
